import init from './lazysizes';

export default () => {
	init();
};
